import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "config-card" };
const _hoisted_2 = { class: "card-header-row" };
const _hoisted_3 = { class: "card-header-info" };
const _hoisted_4 = { class: "card-title" };
const _hoisted_5 = { class: "card-description" };
const _hoisted_6 = { class: "toggle-wrapper" };
const _hoisted_7 = { class: "toggle-label" };
const _hoisted_8 = ["disabled"];
const _hoisted_9 = {
    key: 0,
    class: "field-group mt-15 mb-20 px-10"
};
const _hoisted_10 = { class: "locale-tabs" };
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
    key: 1,
    class: "message-block"
};
const _hoisted_13 = { class: "message-block-header" };
const _hoisted_14 = { class: "channel-badge push" };
const _hoisted_15 = { class: "field-row" };
const _hoisted_16 = { class: "field-group" };
const _hoisted_17 = ["placeholder"];
const _hoisted_18 = { class: "field-group" };
const _hoisted_19 = ["placeholder"];
const _hoisted_20 = {
    key: 0,
    class: "hint mt-5 d-block"
};
const _hoisted_21 = {
    key: 2,
    class: "message-block"
};
const _hoisted_22 = { class: "message-block-header" };
const _hoisted_23 = { class: "channel-badge email" };
const _hoisted_24 = { class: "field-group" };
const _hoisted_25 = ["placeholder"];
const _hoisted_26 = { class: "field-group" };
const _hoisted_27 = ["placeholder"];
const _hoisted_28 = { class: "card-footer" };
const _hoisted_29 = ["disabled"];
const _hoisted_30 = {
    key: 0,
    class: "btn-spinner"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = _resolveComponent("v-select");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.title), 1),
                _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.description), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.localConfig.is_active ? 'Actif' : 'Inactif'), 1),
                _createElementVNode("button", {
                    class: _normalizeClass(['toggle-btn', { active: _ctx.localConfig.is_active }]),
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.handleToggle && _ctx.handleToggle(...args))),
                    disabled: !_ctx.localConfig.id
                }, [...(_cache[7] || (_cache[7] = [
                        _createElementVNode("span", { class: "toggle-knob" }, null, -1)
                    ]))], 10, _hoisted_8)
            ])
        ]),
        _renderSlot(_ctx.$slots, "delay", {}, undefined, true),
        (_ctx.couponTemplates.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _cache[8] || (_cache[8] = _createElementVNode("label", { class: "field-label" }, "🎁 Coupon lié (Template)", -1)),
                _createVNode(_component_v_select, {
                    modelValue: _ctx.localConfig.linked_coupon_config_id,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.localConfig.linked_coupon_config_id) = $event)),
                    options: _ctx.couponTemplates,
                    label: "code",
                    reduce: c => c.id,
                    placeholder: "Choisir un modèle de coupon",
                    class: "custom-v-select"
                }, null, 8, ["modelValue", "options", "reduce"]),
                _cache[9] || (_cache[9] = _createElementVNode("small", { class: "hint mt-5 d-block" }, [
                    _createTextVNode("Utilisez "),
                    _createElementVNode("code", null, "{{COUPON_CODE}}"),
                    _createTextVNode(" dans votre message pour injecter le code généré.")
                ], -1))
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locales, (loc) => {
                return (_openBlock(), _createElementBlock("button", {
                    key: loc.code,
                    class: _normalizeClass(['locale-tab', { active: _ctx.activeLocale === loc.code }]),
                    onClick: ($event) => (_ctx.activeLocale = loc.code)
                }, [
                    _createElementVNode("span", null, _toDisplayString(loc.flag), 1),
                    _createElementVNode("span", null, _toDisplayString(loc.label), 1)
                ], 10, _hoisted_11));
            }), 128))
        ]),
        (_ctx.showPush)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, "🔔 Push (" + _toDisplayString(_ctx.activeLocale.toUpperCase()) + ")", 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                        _cache[10] || (_cache[10] = _createElementVNode("label", { class: "field-label" }, "Titre", -1)),
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.activeTranslation.push_title) = $event)),
                            class: "field-input",
                            placeholder: `Ex: [${_ctx.activeLocale.toUpperCase()}] Vous avez oublié quelque chose...`,
                            maxlength: "100"
                        }, null, 8, _hoisted_17), [
                            [_vModelText, _ctx.activeTranslation.push_title]
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                    _cache[12] || (_cache[12] = _createElementVNode("label", { class: "field-label" }, "Message", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.activeTranslation.push_body) = $event)),
                        class: "field-textarea",
                        placeholder: `Ex: [${_ctx.activeLocale.toUpperCase()}] Votre panier vous attend !`,
                        rows: "3"
                    }, null, 8, _hoisted_19), [
                        [_vModelText, _ctx.activeTranslation.push_body]
                    ]),
                    (_ctx.type === 'ORDER_PUSH')
                        ? (_openBlock(), _createElementBlock("small", _hoisted_20, [...(_cache[11] || (_cache[11] = [
                                _createTextVNode(" Available variables: ", -1),
                                _createElementVNode("code", null, "{{ORDER_NUMBER}}", -1),
                                _createTextVNode(", ", -1),
                                _createElementVNode("code", null, "{{AMOUNT}}", -1),
                                _createTextVNode(", ", -1),
                                _createElementVNode("code", null, "{{CUSTOMER_NAME}}", -1),
                                _createTextVNode(", ", -1),
                                _createElementVNode("code", null, "{{ORDER_TYPE}}", -1)
                            ]))]))
                        : _createCommentVNode("", true)
                ])
            ]))
            : _createCommentVNode("", true),
        (_ctx.showEmail)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, "📧 Email (" + _toDisplayString(_ctx.activeLocale.toUpperCase()) + ")", 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                    _cache[13] || (_cache[13] = _createElementVNode("label", { class: "field-label" }, "Objet de l'email", -1)),
                    _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.activeTranslation.email_subject) = $event)),
                        class: "field-input",
                        placeholder: `Ex: [${_ctx.activeLocale.toUpperCase()}] Votre panier Va Bene vous attend...`
                    }, null, 8, _hoisted_25), [
                        [_vModelText, _ctx.activeTranslation.email_subject]
                    ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                    _cache[14] || (_cache[14] = _createElementVNode("label", { class: "field-label" }, "Corps de l'email (HTML supporté)", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.activeTranslation.email_body) = $event)),
                        class: "field-textarea",
                        placeholder: `Ex: [${_ctx.activeLocale.toUpperCase()}] Votre panier vous attend ! Cliquez ici pour commander...`,
                        rows: "6"
                    }, null, 8, _hoisted_27), [
                        [_vModelText, _ctx.activeTranslation.email_body]
                    ]),
                    _cache[15] || (_cache[15] = _createElementVNode("small", { class: "hint mt-5 d-block" }, "Note: Si vide, un template générique sera utilisé si disponible.", -1))
                ])
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_28, [
            _createElementVNode("button", {
                class: "btn-save",
                onClick: _cache[6] || (_cache[6] =
                    //@ts-ignore
                    (...args) => (_ctx.handleSave && _ctx.handleSave(...args))),
                disabled: _ctx.isSaving
            }, [
                (_ctx.isSaving)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_30))
                    : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(_ctx.isSaving ? 'Enregistrement...' : '💾 Enregistrer'), 1)
            ], 8, _hoisted_29)
        ])
    ]));
}
